import { get, post } from "../axiosUitils";

class SignUpService {
  getCountryCodes = async (): Promise<any> => {
    return await get<any>("/dropdown/countrydetails/");
  };

  sendOtp = async (payload: {
    phone_number?: any;
    phone_code?: any;
    otp?: any;
    code_reference?: any;
  }): Promise<any> => {
    return await post<any>("/auth/login/", payload);
  };

  sendResetOtp = async (payload: {
    code_reference: string;
    otp?: string;
  }): Promise<any> => {
    return await post<any>("/auth/resend-otp/", payload);
  };
}

const instance = new SignUpService();
export default instance;
